import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ScrewdriverGlyph = /*#__PURE__*/createElement("g", {
  id: "screwdriver"
}, /*#__PURE__*/createElement("path", {
  d: "M56.5 68.4c-.9 0-1.9-.4-2.6-1.1L34.6 46.9c-.1-.1-.5-.1-1.3.1h-.1c-4.7.8-9-.7-12.8-4.5-3.8-3.7-4.9-11.1-3.7-13.6 0-.1.1-.1.1-.2l1.2-1.6c.2-.2.4-.4.7-.5 1.2-.4 2.4-.3 3.4.4l6.3 4.5c.2.2.6.2.8 0 .5-.5 1-1 1.3-1.5.3-.5.6-1 .9-1.6.2-.4-.4-.9-.8-1.2l-5.3-3.8c-1-.7-1.6-1.9-1.5-3.1 0-.3.1-.6.3-.8.3-.5 1.5-2 2.7-2.5 5.4-2.5 13-1.3 17.2 2.9 4.2 4.1 5.5 9.7 3.7 15.2 0 .1-.1.3.3.8l18.9 19.3c1.2 1.2 1.3 3.2.3 4.6-2.2 2.9-5.1 5.6-8.6 8-.7.4-1.4.6-2.1.6zM36.8 44.9l19.3 20.3c.2.2.5.2.7.1 3.2-2.2 5.9-4.7 7.9-7.3.1-.2.1-.5 0-.6l-19-19.5-.2-.2c-.6-.8-1.2-2-.7-3.6 1.5-4.5.4-8.8-2.9-12.1-3.3-3.3-9.5-4.3-13.8-2.3-.2.1-.8.6-1.2 1.1 0 .1.1.1.2.2l5.3 3.8c2.8 2 2.1 4.3 1.7 4.9-.4.7-.7 1.4-1.2 2-.5.7-1.1 1.3-1.8 2-1.2 1.2-3.2 1.3-4.6.3l-6.3-4.5c-.1-.1-.2-.1-.3-.1l-.7 1c-.5 1.3.2 7.2 3.1 10 3.1 3.1 6.5 4.3 10.1 3.7 2.8-.7 4 .3 4.4.8zm-2.4 1.8zm0 0zm0 0zm0 0z"
}));
const Screwdriver = createSvg({
  name: 'screwdriver',
  path: ScrewdriverGlyph
});

export default Screwdriver;
export { ScrewdriverGlyph };
